module.exports = __webpack_public_path__ + "static/img/4.82cfaf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/2020-1.19/4.jpg
// module id = VrLB
// module chunks = 1